module.exports = __webpack_public_path__ + "static/media/nyd-poster.3a86ff59.pdf";